import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./BlogList.module.css";

const BlogCard = ({ blog, onClick }) => {
  const navigate = useNavigate();

  const handleAuthorClick = (e) => {
    e.stopPropagation();
    // navigate(`/Realtors-and-Brokers/${blog?.pro_id}`);
  };

  return (
    <div className={`${styles.blogItem}`} onClick={() => onClick(blog)}>
      <div className={styles.blogImageContainer}>
        <img
          src={blog.image_url?.trim() || ""}
          alt={blog.title}
          className={styles.blogImage}
          onError={(e) => {
            e.target.onerror = null;
            e.target.style.display = "none";
            const placeholder = e.target.nextElementSibling;
            if (placeholder) placeholder.style.display = "flex";
          }}
        />
        <div className={styles.placeholderImage} style={{ display: "none" }}>
          No Image Available
        </div>
      </div>

      <div className={styles.blogContent} onClick={handleAuthorClick}>
        <h2 className={styles.blogTitle}>{blog.title}</h2>
        <div className={styles.blogInfo}>
          <p className={styles.author}>
            By {blog.pro_first_name} {blog.pro_last_name}
          </p>
          <p className={styles.date}>
            {new Date(blog.created_at).toLocaleDateString()}
          </p>
        </div>
        <p
          className={styles.summary}
          dangerouslySetInnerHTML={{ __html: blog.description }}
        />
      </div>
    </div>
  );
};

export default BlogCard;
